import { createStyles, Theme } from '@material-ui/core';

export default ({ spacing: { unit } }: Theme) =>
  createStyles({
    rescheduler: {
      width: '100%',
      maxWidth: 264,
      boxSizing: 'border-box',
      height: 'fit-content',
      padding: `${unit * 1.5}px ${unit * 2.5}px ${unit * 2.5}px`,
      backgroundColor: '#fff',
      boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.16)',
      borderRadius: '8px',
      marginBottom: unit * 2,
      marginLeft: unit * 4,
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: `${unit}px`,
    },
  });
